import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageAnnemasse: React.FC = () => (
  <LocalSeoPage
    city="Annemasse"
    slug="depannage-informatique-annemasse"
    metaTitle="Dépannage Informatique Annemasse | Technicien PC | SOS IT"
    metaDescription="Dépannage PC et Mac à Annemasse. Suppression virus, récupération de données, optimisation. Rapide et efficace. Appelez !"
    intro="Votre ordinateur vous lâche à Annemasse ? Virus, PC lent, panne Windows ou problème de réseau — nos techniciens interviennent rapidement à domicile ou à distance. Pas besoin de vous déplacer : on résout la plupart des pannes en ligne, depuis votre salon."
    postalCode="74100"
    nearbyTowns={[
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Viry', link: '/depannage-informatique-viry' },
      { name: 'Annecy', link: '/depannage-informatique-annecy' },
      { name: 'Gaillard' },
      { name: 'Ambilly' },
      { name: 'Ville-la-Grand' },
      { name: 'Cranves-Sales' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique à Viry', href: '/depannage-informatique-viry' },
      { label: 'Dépannage informatique à Annecy', href: '/depannage-informatique-annecy' },
      { label: 'Dépannage informatique dans le Genevois', href: '/depannage-informatique-genevois' },
    ]}
  />
);

export default DepannageAnnemasse;
